export default __webpack_public_path__ + "static/ofakim-rash-af1caeea5e62d8d37e280564fecc935b.png";